import { MenuItem, OutlinedInput, Select, useTheme } from "@mui/material";
import React, { useState } from "react";
import LoadingIndicator from "../../../components/loading-indicator/LoadingIndicator";
import BarChartComponent from "./BarChartComponent";
import DonutChartComponent from "./DonutChartComponent";
import PieChartComponent from "./PieChartComponent";

const AllChartComponent = (props) => {
  const [chart, setChart] = useState({});

  const handleChange = (event, index) => {
    setChart({ value: event.target.value, index: index });
  };

  const theme = useTheme();

  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
        <div style={{ width: "20%" }}>
          <Select
            value={chart.value}
            size="small"
            label={false}
            sx={{ width: "100%" }}
            placeholder="Chart"
            onChange={(event) => handleChange(event)}
            defaultValue={"bar"}
            inputProps={{
              "aria-label": "Without label",
            }}
          >
            <MenuItem disabled={chart.value === "bar"} value={"bar"}>
              Bar Chart
            </MenuItem>
            <MenuItem disabled={chart.value === "pie"} value={"pie"}>
              Pie Chart
            </MenuItem>
            <MenuItem disabled={chart.value === "donut"} value={"donut"}>
              Donut Chart
            </MenuItem>
          </Select>
        </div>
      </div>
      {props && props.list && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {chart.value === "pie" ? (
            <div style={{ width: "50%" }}>
              <PieChartComponent list={props.list} />
            </div>
          ) : chart.value === "donut" ? (
            <div style={{ width: "50%" }}>
              <DonutChartComponent list={props.list} />
            </div>
          ) : (
            <div style={{ width: "70%" }}>
              <BarChartComponent list={props.list} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AllChartComponent;
